<template>
  <div>
    <v-container class="py-0 px-0">
      <v-card tile>
        <v-card-text class="py-0">
          <v-container class="px-0">
            <v-row>
              <v-col cols="12" sm="6" md="3" class="fit-content">
                <v-text-field
                  label="Tanggal"
                  dense
                  small-chips
                  hide-details
                  type="date"
                  v-model="formData.tgl"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3" class="fit-content">
                <!-- <v-text-field
                  label="Kode TTPB"
                  dense
                  small-chips
                  hide-details
                  type="text"
                  v-model="formData.ttpb"
                ></v-text-field> -->

                <v-combobox
                  v-model="formData.ttpb"
                  label="Kode TTPB"
                  :items="items.ttpb"
                  :loading="loading.ks"
                  :disabled="loading.ks"
                  hide-details
                  dense
                >
                </v-combobox>
              </v-col>
              <v-col cols="12" sm="6" md="3" class="fit-content">
                <v-text-field
                  label="Nama Penerima"
                  dense
                  small-chips
                  hide-details
                  type="text"
                  v-model="formData.nama_penerima"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3" class="fit-content">
                <v-text-field
                  label="Nama Pengantar"
                  dense
                  small-chips
                  hide-details
                  type="text"
                  v-model="formData.nama_pengantar"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6" class="fit-content">
                <v-text-field
                  label="Kondisi Penerimaan"
                  dense
                  small-chips
                  hide-details
                  type="text"
                  v-model="formData.kondisi_penerimaan"
                  @keydown.enter="saveData"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6" class="fit-content">
                <v-text-field
                  label="Catatan"
                  dense
                  small-chips
                  hide-details
                  type="text"
                  v-model="formData.catatan"
                  @keydown.enter="saveData"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="1" class="fit-content">
                <v-btn
                  color="primary"
                  :loading="loading.saveData"
                  :disabled="loading.saveData"
                  @click="saveData"
                  small
                >
                  Save
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>

      <v-data-table
        :headers="TTPBKembaliHeaders"
        :items="TTPBKembali"
        :loading="loading.TTPBKembali"
        :items-per-page="5"
        class="elevation-1 mt-2"
        dense
      >
        <template v-slot:item.tgl="{ item }">
          {{ formatDate(item.tgl) }}
        </template>
      </v-data-table>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";
import { sync } from "vuex-pathify";

export default {
  name: "ContainerModal",
  props: ["openModal"],
  data() {
    return {
      loading: {
        saveData: false,
        TTPBKembali: false,
        ks: false
      },
      formData: {
        tgl: "",
        ttpb: "",
        nama_penerima: "",
        nama_pengantar: "",
        kondisi_penerimaan: "Diterima dengan baik dan Utuh",
        catatan: ""
      },
      TTPBKembaliHeaders: [
        { text: "TTPB", value: "ttpb" },
        { text: "Tanggal", value: "tgl" },
        { text: "Penerima", value: "penerima" },
        { text: "Pengantar", value: "pengantar" },
        { text: "Kondisi", value: "kondisi_penerimaan" },
        { text: "Catatan", value: "catatan" }
      ],
      TTPBKembali: [],
      items: {
        ttpb: []
      }
    };
  },
  methods: {
    async fetchData() {
      this.loading.TTPBKembali = true;

      axios
        .get("ttpb-kembali")
        .then(res => {
          this.TTPBKembali = res.data;

          this.loading.TTPBKembali = false;
        })
        .catch(err => {
          this.loading.TTPBKembali = false;

          alert(err.response.data.message);
        });
    },
    async saveData() {
      this.loading.saveData = true;

      await axios
        .post(`ttpb-kembali`, this.formData)
        .then(res => {
          this.loading.saveData = false;

          this.fetchData();
          this.resetFormData();
        })
        .catch(err => {
          this.loading.saveData = false;

          alert(err.response.data.message);
        });
    },
    async fetchTTPB() {
      this.loading.ks = true;

      await axios
        .get(`ttpb`)
        .then(res => {
          // this.items.ttb = res.data.map(item => ({
          //   text: `${item.kodettb} - ${item.nottb} dari: ${
          //     item.pengirim_detil ? item.pengirim_detil.nama : ""
          //   }; utk: ${
          //     item.penerima_detil ? item.penerima_detil.nama : ""
          //   }; TKoli: ${item.total_koli}; sisa: ${item.sisa}`,
          //   value: item.kodettb
          // }));

          this.items.ttpb = res.data.map(item => ({
            text: `${item.ks} - dari: ${
              item.ttb.pengirim_detil ? item.ttb.pengirim_detil.nama : ""
            }; utk: ${
              item.ttb.penerima_detil ? item.ttb.penerima_detil.nama : ""
            }`,
            value: item.ks
          }));

          // console.log(res.data);

          this.loading.ks = false;
        })
        .catch(err => {
          this.loading.ks = false;

          alert(err.response.data.message);
        });
    },
    resetFormData() {
      this.formData.ttpb = "";
      this.formData.nama_penerima = "";
      this.formData.nama_pengantar = "Diterima dengan baik dan Utuh";
      this.formData.catatan = "";
    },
    formatDate(date) {
      const newDate = new Date(date);

      return `${String(newDate.getDate()).padStart(2, "0")}-${String(
        newDate.getMonth() + 1
      ).padStart(2, "0")}-${newDate.getFullYear()}`;
    }
  },
  created() {
    this.fetchTTPB();
    this.fetchData();
  }
};
</script>

<style scoped>
.fit-content {
  height: fit-content;
}

table thead th {
  font-size: 12px !important;
}

.input {
  border: 1px solid lightgray;
  padding: 1px 4px;
  outline: none;
  width: 100%;
}

.w-100 {
  width: 100%;
}

input[type="date"]::-webkit-inner-spin-button,
input[type="date"]::-webkit-calendar-picker-indicator {
  display: none;
  -webkit-appearance: none;
}

.no-wrap {
  white-space: nowrap;
}

.without_ampm::-webkit-datetime-edit-ampm-field {
  display: none;
}

input[type="time"]::-webkit-clear-button {
  -webkit-appearance: none;
  -moz-appearance: none;
  -o-appearance: none;
  -ms-appearance: none;
  appearance: none;
  margin: -10px;
}
</style>
